import {popupWin} from "../assets-static/scripts/utils";

export let formatValues = {
    year: new Date().getFullYear(),
    br: <br />,
    'link-to-terms': (chunks) => <a href="#"
                                    onClick={() => popupWin('/application-center/terms-of-use')}>{chunks}</a>,
    'link-to-privacy': (chunks) => <a href="#"
                                      onClick={() => popupWin('/application-center/privacy-policy')}>{chunks}</a>,
}
